module.exports = __webpack_public_path__ + "static/media/holt_logo.66a94df1.png";